module.exports = __webpack_public_path__ + "static/media/carousel2.8394e74c.webp";